import * as React from 'react'
import '../styles/App.scss'
import '../styles/NewAccount.scss'
import '../styles/ReactSelect.scss'
import 'react-datepicker/dist/react-datepicker.css'
import { FlatButton, Avatar, Badge } from 'material-ui'
import { AppBarContainer } from './CustomAppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Api } from '../services/api/api'
import Stripe from '../services/stripe/stripe'
import Currencies from '../types/enums/Currencies'
import Countries from '../types/enums/Counties'
import images from '../images'
import PageTitle from '../components/PageTitle'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { FormValidator, FieldValidatedValue } from '../utils/validation/FormValidator'
import * as Validators from '../utils/validation/Validators'
import { Strings } from '../localization'
import * as classnames from 'classnames'
import { isNullOrUndefined } from 'util'
import { Validator } from '../utils/validation/Validator'
import { PasswordChecker } from '../components/PasswordChecker'
import { connect, Dispatch } from 'react-redux'
import { RouterAction, routerActions } from 'react-router-redux'
import * as Auth from '../services/auth/auth'
import { ClientInfo, Preference } from '../types'
import { ROUTES, DEFAULT_ROUTE } from '../constants/routes'
import {ActionType as SignInActionType, Actions as SignInActions} from '../actions/signIn'
import { StickyContainer, Sticky } from 'react-sticky'
import Select from 'react-select'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Masker } from '../utils/masker/Masker'
import { StringResources } from '../localization/StringResources'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import MessageDialog, {MessageDialogProps} from '../components/MessageDialog';
import {PreferenceType} from '../types/enums/PreferenceType';

interface NewAccountState {
  accountPic: any,
  avatarInput: any,
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  password: string,
  passwordConformation: string
  tabValue: number

  cardNumber: number | undefined | string,
  cardExpirationDate: undefined | string,
  cvv: number | undefined | string

  isRegistrationInProcess: boolean

  formPersonalInfo: FormPersonalInfoType
  formPaymentInfo: FormPaymentInfoType
  errorText?: string
  fieldsPersonalInfoError: boolean
  fieldsPaymentInfoError: boolean

  registrationProcessText: string,

  messageDialog: MessageDialogProps
}

interface NewAccountProps {
  onUserSigned: (userData: ClientInfo) => SignInActionType
  onSetTutorialLink: (link: Preference) => SignInActionType
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
  onLogOut: () => SignInActionType
  routePush: (location: string) => RouterAction
}

enum FormPersonalInfoFields {
  FirstName = 'firstNameInput',
  LastName = 'lastNameInput',
  Password = 'passwordInput',
  PasswordConformation = 'passwordConformationInput',
  Email = 'emailInput',
  Phone = 'phoneInput',
  ZipCode = 'zipCodeInput',
  Avatar = 'avatarInput'
}
enum FormPaymentInfoFields {
  CardNumber = 'cardNumberInput',
  CardExpirationDate = 'cardExpirationDateInput',
  CardCvv = 'cardCvvInput'
}

interface FormPersonalInfoType {
  [FormPersonalInfoFields.FirstName]: FieldValidatedValue
  [FormPersonalInfoFields.LastName]: FieldValidatedValue
  [FormPersonalInfoFields.Email]: FieldValidatedValue
  [FormPersonalInfoFields.Phone]: FieldValidatedValue
  [FormPersonalInfoFields.ZipCode]: FieldValidatedValue
  [FormPersonalInfoFields.Password]: FieldValidatedValue
  [FormPersonalInfoFields.PasswordConformation]: FieldValidatedValue
  [FormPersonalInfoFields.Avatar]: FieldValidatedValue
}
interface FormPaymentInfoType {
  [FormPaymentInfoFields.CardNumber]: FieldValidatedValue
  [FormPaymentInfoFields.CardExpirationDate]: FieldValidatedValue
  [FormPaymentInfoFields.CardCvv]: FieldValidatedValue
}
// TODO: Delete all unused state variables and handling functions. Move to formInfo values
class NewAccount extends React.Component<NewAccountProps, NewAccountState> {

  private _stripe: Stripe
  private formPersonalInfoValidator: FormValidator<FormPersonalInfoType>
  private formPaymentInfoValidator: FormValidator<FormPaymentInfoType>

  constructor(props) {
    super(props)
    this.formPersonalInfoValidator = this.initPersonalInfoForm()
    this.formPaymentInfoValidator = this.initPaymentInfoForm()
    this.state = {
      accountPic: '',
      avatarInput: '',
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      password: '',
      passwordConformation: '',
      tabValue: 1,

      cardNumber: '',
      cardExpirationDate: '',
      cvv: '',

      isRegistrationInProcess: false,
      formPersonalInfo: this.formPersonalInfoValidator.values(),
      formPaymentInfo: this.formPaymentInfoValidator.values(),
      fieldsPersonalInfoError: false,
      fieldsPaymentInfoError: false,

      registrationProcessText: '',
      messageDialog:{
        isDialogOpened:false
      },
    }
  }

  componentDidMount() {
    Stripe.getStripe().then(stripe => {
      this._stripe = stripe
      console.log(stripe)
    })
      .catch(error => {
        console.log('resolving stripe obj error')
        console.log(error)
      })
  }

  get fullName() {
    return this.state.firstName + ' ' + this.state.lastName
  }

  get CardExpMonth() {
    // tslint:disable-next-line:radix
    return parseInt((this.state.cardExpirationDate as string).split('/')[0])
  }

  get CardExpYear() {
    // tslint:disable-next-line:radix
    return parseInt((this.state.cardExpirationDate as string).split('/')[1])
  }

  SignIn = async (noRedirect:boolean) => {
    try {
      let signInResp = await Auth.signIn({ login: this.state.email, password: this.state.password })
      console.log(signInResp)
      await this.getAndSaveUserData(noRedirect)
      let link = await Api.getPreference(PreferenceType.TutorialLink)
      console.log('Tutorial link: ', link)
      this.props.onSetTutorialLink(link)
    } catch (error) {
      console.log('sign in error', error)
      this.props.onErrorEvent(Mapper.mapError(error))
    }
  }

  getAndSaveUserData = async (noRedirect:boolean) => {
    await Api.getClientInfo()
      .then((userData: ClientInfo) => {
        console.log(userData)
        this.props.onUserSigned(userData)
        if(!noRedirect)
          this.props.routePush(DEFAULT_ROUTE)
      })
      .catch(error => {
        console.log(error)
        this.props.onErrorEvent(Mapper.mapError(error))
      })
  }

  validatePersonalInfoFields = () => {
    return new Promise(async (resolve) => {
      this.formPersonalInfoValidator.validate()

      const zipField = this.formPersonalInfoValidator.value(FormPersonalInfoFields.ZipCode);
      if(!zipField.error){
        try{
          await Api.getMsaByZip(zipField.value);
        }catch(e){
          this.formPersonalInfoValidator.setError(name, 'Please enter a valid zip', true)
        }
      }

      this.setState({
        formPersonalInfo: this.formPersonalInfoValidator.values(),
        fieldsPersonalInfoError: !this.formPersonalInfoValidator.isValid(),
        errorText: this.formPersonalInfoValidator.getError(),
      }, () => { resolve() })
    })
  }

  validatePaymentInfoFields = () => {
    return new Promise((resolve) => {
      this.formPaymentInfoValidator.validate()
      this.setState({
        formPaymentInfo: this.formPaymentInfoValidator.values(),
        fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
        errorText: this.formPaymentInfoValidator.getError()
      }, () => { resolve() })
    })
  }
  _renderPaymentInformation() {
    return (
      <div className="new-account">
        <form className="signup-form">
          <div className="info-text">
            {StringResources.getString(Strings.NewAccount.PaymentInformation.TopInfoText)}
            <br />
            {StringResources.getString(Strings.NewAccount.PaymentInformation.TopInfoText2)}
          </div>
          <input
            className={classnames('card-number', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].error })}
            type="text"
            name={FormPaymentInfoFields.CardNumber}
            placeholder={StringResources.getString(Strings.NewAccount.PaymentInformation.Widgets.CardNumber.placeholder)}
            value={this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked ?
              this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked : ''}
            onChange={this.handleCardNumberChange}
            maxLength={19}
          />
          <input
            className={classnames('expiration-date half-sized left-input', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].error })}
            type="text"
            name={FormPaymentInfoFields.CardExpirationDate}
            value={this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked ?
              this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked : ''}
            onChange={this.handleCardExpirationDateChange}
            placeholder={StringResources.getString(Strings.NewAccount.PaymentInformation.Widgets.ExpirationDate.placeholder)}
            maxLength={5}
          />
          <input
            name={FormPaymentInfoFields.CardCvv}
            className={classnames('cvv', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].error })}
            type="text"
            placeholder={StringResources.getString(Strings.NewAccount.PaymentInformation.Widgets.CVV.placeholder)}
            value={this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].value}
            onChange={this.handleCvvChange}
            required={true}
            maxLength={4}
          />
          <img src={images.securePaymentShrinked} alt="" />
        </form>
      </div>
    )
  }

  _renderPersonalInfo = () => {
    return (
      <div>
        <form className="signup-form">
          <input
            type="text"
            name={FormPersonalInfoFields.FirstName}
            className={classnames('left-input', { error: this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].error })}
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.FirstName.placeholder)}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].value}
            onChange={this.handleFirstNameChange}
          />
          <input
            type="text"
            name={FormPersonalInfoFields.LastName}
            className={classnames({ error: this.state.formPersonalInfo[FormPersonalInfoFields.LastName].error })}
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.LastName.placeholder)}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.LastName].value}
            onChange={this.handleLastNameChange}
          />
          <input
            id="input-long-email"
            type="email"
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.Email.placeholder)}
            name={FormPersonalInfoFields.Email}
            className={classnames({ error: this.state.formPersonalInfo[FormPersonalInfoFields.Email].error })}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.Email].value}
            onChange={this.handleEmailChange}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
          />
          <input
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.Phone.placeholder)}
            name={FormPersonalInfoFields.Phone}
            className={classnames('left-input', { error: this.state.formPersonalInfo[FormPersonalInfoFields.Phone].error })}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.Phone].masked ?
              this.state.formPersonalInfo[FormPersonalInfoFields.Phone].masked : ''}
            onChange={this.handlePhoneChange}
          />
          <input
              id="input-zipCode"
              placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.ZipCode.placeholder)}
              name={FormPersonalInfoFields.ZipCode}
              className={classnames({ error: this.state.formPersonalInfo[FormPersonalInfoFields.ZipCode].error })}
              value={this.state.formPersonalInfo[FormPersonalInfoFields.ZipCode].masked ?
                  this.state.formPersonalInfo[FormPersonalInfoFields.ZipCode].masked : ''}
              onChange={this.handleZipCodeChange}
              onBlur={this.handleZipCodeBlur}
          />
          <input
            type="password"
            name={FormPersonalInfoFields.Password}
            className={classnames('left-input', { error: this.state.formPersonalInfo[FormPersonalInfoFields.Password].error })}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.Password].value}
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.Password.placeholder)}
            onChange={this.handlePasswordChange}
          />
          <input
            type="password"
            name={FormPersonalInfoFields.PasswordConformation}
            className={classnames({ error: this.state.formPersonalInfo[FormPersonalInfoFields.PasswordConformation].error })}
            placeholder={StringResources.getString(Strings.NewAccount.PersonalInfo.Widgets.PasswordConformation.placeholder)}
            value={this.state.formPersonalInfo[FormPersonalInfoFields.PasswordConformation].value}
            onChange={this.handlePasswordConformationChange}
          />
        </form>
        <div className="password-checker-container password-policies">
          <div>
            <PasswordChecker
              password={this.state.password}
              confirmPassword={this.state.passwordConformation}
            />
          </div>
        </div>
      </div>
    )
  }

  handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ firstName: event.target.value })
  }
  handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ lastName: event.target.value })
  }
  handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ phone: event.target.value })
  }
  handleZipCodeChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
  }
  handleZipCodeBlur = (event: React.FocusEvent<HTMLInputElement>) => {
      this.updateZipCodeValueWithValidation(event.target.name, event.target.value);
  }
  handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ email: event.target.value })
  }
  handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ password: event.target.value })
  }
  handlePasswordConformationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePersonalInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ passwordConformation: event.target.value })
  }

  selectTab = async (event: React.ChangeEvent<HTMLInputElement>, value: number) => {
    if (value === 2) {
      await this.validatePersonalInfoFields()
      if (!this.state.fieldsPersonalInfoError) {
        this.setState({ tabValue: value })
      }
    } else {
      this.setState({ tabValue: value })
    }

  }

  buttonNextTabClick = async () => {
    await this.validatePersonalInfoFields()
    if (!this.state.fieldsPersonalInfoError) {
      this.setState({ tabValue: 2 })
    }
  }
  /* remove client avatar https://gotrashyinc.atlassian.net/browse/GT2-1696

  handleFileUpload = (event) => {
    console.log(event)
    let file = event.target.files[0]
    if (file != null) {
      let fileUrl = URL.createObjectURL(file)
      // this.updatePersonalInfoValueWithValidation(event.target.name, fileUrl)
      this.setState({ accountPic: fileUrl })
    }
  }
  handleAvatarClick = () => {
    let fileUpload = ReactDOM.findDOMNode(this.refs['refAvatarInput']) as HTMLInputElement
    if (fileUpload != null) {
      fileUpload.click()
    }
  }

  handleImageRemoval = () => {
    this.setState({ accountPic: '', avatarInput: '' })
  }
*/
  handleCvvChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePaymentInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ cvv: event.target.value })
  }
  handleCardNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePaymentInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ cardNumber: event.target.value })
  }
  handleCardExpirationDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.updatePaymentInfoValueWithValidation(event.target.name, event.target.value)
    this.setState({ cardExpirationDate: event.target.value })
  }

  buildPhoneNumber = () => {
    let mobilePhone = '+1'
    let { length } = this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value
    for (let i = 0; i < length; i++) {
      if (!isNaN(Number(this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value[i]))) {
        mobilePhone += this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value[i]
      }
    }
    return mobilePhone
  }

  onSkipCreditCard = async () => {
    if(await this.registerClient(false)) {
      this.setState({
        isRegistrationInProcess: true,
        registrationProcessText: 'Registration Completed. Signing you in.'
      })
      await this.SignIn(false);
      this.setState({ isRegistrationInProcess: false })
    }
  }
  onBusinessSignUp = async () => {
    if(await this.registerClient(true)) {
      this.setState({
        isRegistrationInProcess: true,
        registrationProcessText: 'Finishing registration.'
      })
      await this.SignIn(true);
      const message = await Api.getPreference(PreferenceType.BusinessSignUpMessage);
      this.setState({
        isRegistrationInProcess: false,
        messageDialog: {
          isDialogOpened: true,
          message: message.value,
          title: 'Business Sign Up',
          actions: [
            {caption: 'Close', onClick: this.handleMessageDialogClose}
          ]
        }
      })
    }
  }
  handleMessageDialogClose = async ()=>{
    this.setState({
      isRegistrationInProcess: true,
      registrationProcessText: '',
      messageDialog: {
        isDialogOpened:false
      }
    });
    const redirectTo = await Api.getPreference(PreferenceType.BusinessSignUpRedirectLink);
    await Auth.signOut();
    this.props.onLogOut();
    window.location.replace(redirectTo.value);
  }
  registerClient = async (commercial:boolean):Promise<boolean> => {
    await this.validatePersonalInfoFields()
    if (this.state.fieldsPersonalInfoError) {
      return false;
    }
    this.setState({
      isRegistrationInProcess: true,
      registrationProcessText: StringResources.getString(Strings.NewAccount.RegistrationProcessSpinner.InitialText)
    })
    let zipcode = this.state.formPersonalInfo[FormPersonalInfoFields.ZipCode].value as string
    let msaObject = await Api.getMsaByZip((zipcode && zipcode.length === 5) ? zipcode : '01029')
    console.log('msa object', msaObject)
    let msaId = msaObject.msaId

    let client = {
      msaId: msaId ? msaId : '40f26d58-eb13-4ebc-9b73-e0182fae0475',
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.buildPhoneNumber(),
      email: this.state.email,
      password: this.state.password,
      clientType: commercial ? 'COMMERCIAL' : undefined
    }
    console.log(this.buildPhoneNumber())
    try {
      let clientResponse = await Api.createClient(client)
      console.log('create client response', clientResponse)
      let idToken = clientResponse.AuthenticationResult.IdToken
      if (!isNullOrUndefined(images.avatar2)) {

        let attachmentObj = await Api.getAvatarId(idToken, client.email)
        console.log('get avatar id', attachmentObj)

        let uploadImageResult = await Api.uploadImage(attachmentObj, images.avatar2)
        console.log('upload image result', uploadImageResult)
      }

      return true;
    } catch (error) {
      console.log('on create new account error', error)
      this.props.onErrorEvent(Mapper.mapError(error))
      this.setState({ isRegistrationInProcess: false })
      return false;
    }
  }

  onCreateNewAccount = async () => {
    await this.validatePersonalInfoFields()
    await this.validatePaymentInfoFields()
    if (this.state.fieldsPersonalInfoError || this.state.fieldsPaymentInfoError) {
      return
    }
    this.setState({
      isRegistrationInProcess: true,
      registrationProcessText: StringResources.getString(Strings.NewAccount.RegistrationProcessSpinner.InitialText)
    })
    let zipcode = this.state.formPersonalInfo[FormPersonalInfoFields.ZipCode].value as string
    let msaObject = await Api.getMsaByZip((zipcode && zipcode.length === 5) ? zipcode : '01029')
    console.log('msa object', msaObject)
    let msaId = msaObject.msaId

    let client = {
      msaId: msaId ? msaId : '40f26d58-eb13-4ebc-9b73-e0182fae0475',
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.buildPhoneNumber(),
      email: this.state.email,
      password: this.state.password
    }
    console.log(this.buildPhoneNumber())
    try {
      let stripeToken = await this._stripe.createToken({
        cardNumber: (this.state.cardNumber as string),
        name: this.fullName,
        cvc: this.state.cvv as number,
        expireMonth: this.CardExpMonth,
        expireYear: this.CardExpYear,
        country: Countries.US,
        currency: Currencies.USD
      })

      if (stripeToken.id === undefined) {
        let errMsg = stripeToken.error.message || 'stripe id is empty'
        console.log(errMsg)
      }

      let clientResponse = await Api.createClient(client)
      console.log('create client response', clientResponse)
      let idToken = clientResponse.AuthenticationResult.IdToken
      if (!isNullOrUndefined(images.avatar2)) {

        let attachmentObj = await Api.getAvatarId(idToken, client.email)
        console.log('get avatar id', attachmentObj)

        let uploadImageResult = await Api.uploadImage(attachmentObj, images.avatar2)
        console.log('upload image result', uploadImageResult)
      }
      this.setState({
        isRegistrationInProcess: true,
        registrationProcessText: StringResources.getString(Strings.NewAccount.RegistrationProcessSpinner.SendingStripeToken)
      })

      let apiSendStripeToken = await Api.sendStripeToken(stripeToken.id, idToken)
      console.log('registration succeeded', apiSendStripeToken)

      this.setState({
        isRegistrationInProcess: true,
        registrationProcessText: 'Registration Completed. Signing you in.'
      })

      await this.SignIn(false)

    } catch (error) {
      console.log('on create new account error', error)
      this.props.onErrorEvent(Mapper.mapError(error))
    }
    this.setState({ isRegistrationInProcess: false })
  }

  updatePersonalInfoValueWithValidation = (name: string, value: any) => {
    return new Promise(resolve => {
      this.formPersonalInfoValidator.setState([{
        name: name,
        value: value
      }])
      this.setState({
        formPersonalInfo: this.formPersonalInfoValidator.values(),
        fieldsPersonalInfoError: !this.formPersonalInfoValidator.isValid(),
        errorText: this.formPersonalInfoValidator.getError()
      }, () => { resolve() })
    })
  }
  updateZipCodeValueWithValidation = async (name: string, value: string) => {
      this.formPersonalInfoValidator.setState([{ name, value }])

      if(!this.formPersonalInfoValidator.value(name).error){
          try{
              await Api.getMsaByZip(value);
          }catch(e){
              this.formPersonalInfoValidator.setError(name, 'Please enter a valid zip')
          }
      }

      this.setState({
          formPersonalInfo: this.formPersonalInfoValidator.values(),
          fieldsPersonalInfoError: !this.formPersonalInfoValidator.isValid(),
          errorText: this.formPersonalInfoValidator.getError(),
      })
  }

  updatePaymentInfoValueWithValidation = (name: string, value: any) => {
    return new Promise(resolve => {
      this.formPaymentInfoValidator.setState([{
        name: name,
        value: value
      }])
      this.setState({
        formPaymentInfo: this.formPaymentInfoValidator.values(),
        fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
        errorText: this.formPaymentInfoValidator.getError()
      }, () => { resolve() })
    })
  }

  render() {
    return (
      <BaseContainer pageName={EventType.NEW_ACCOUNT}>
        <LoadingSpinner show={this.state.isRegistrationInProcess} text={this.state.registrationProcessText} />
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={false}
        />
        <PageTitle text={StringResources.getString(Strings.NewAccount.Title)} />
        <PerfectScrollbar className="vertical-scrollbar rh" >
          <div className="info-tabs">
            <Tabs
              value={this.state.tabValue}
              classes={{ indicator: 'info-tabs-indicator' }}
              onChange={this.selectTab}
              fullWidth={true}
            >
              <Tab
                classes={{ root: 'info-tab', selected: 'info-tab-selected' }}
                label={StringResources.getString(Strings.NewAccount.PersonalInfo.Label)}
                value={1}
              />
              <Tab
                classes={{ root: 'info-tab', selected: 'info-tab-selected' }}
                className={classnames({ disabled: this.state.fieldsPersonalInfoError })}
                label={StringResources.getString(Strings.NewAccount.PaymentInformation.Label)}
                value={2}
                disabled={this.state.fieldsPersonalInfoError}
              />
            </Tabs>
          </div>
          <div className={classnames('alertMessage', { active: (this.state.fieldsPersonalInfoError || this.state.fieldsPaymentInfoError) && !isNullOrUndefined(this.state.errorText) })}>
            {('Error! ' + this.state.errorText)}
          </div>
          {
            this.state.tabValue === 1 ? this._renderPersonalInfo() : this._renderPaymentInformation()
          }
        </PerfectScrollbar>
        <MessageDialog {...this.state.messageDialog} />
        <StickyContainer className="sticky-footer onRegister" >
          <Sticky>
            {() => (
              <div className={'bottom-part hover'}>
                <div className={classnames('shadowPart', { active: this.state.isRegistrationInProcess })} />

                {/*{this.state.tabValue === 2 && <div><a href={'javascript:void(0)'} onClick={this.onBusinessSignUp}>{StringResources.getString(Strings.NewAccount.BottomActions.BusinessSignUp)}</a></div>}*/}
                {this.state.tabValue === 2 && <div style={{ marginTop:  '15px', marginBottom: '5px' }}><a href={'javascript:void(0)'} onClick={this.onSkipCreditCard}>{StringResources.getString(Strings.NewAccount.BottomActions.SkipCreditCard)}</a></div>}
                <FlatButton
                  label={this.state.tabValue === 1 ?
                    StringResources.getString(Strings.NewAccount.BottomButton.NextLabel) :
                    StringResources.getString(Strings.NewAccount.BottomButton.CreateLabel)}
                  className={classnames('flatbutton', { disabled: this.state.tabValue === 1 ? this.state.fieldsPersonalInfoError : this.state.fieldsPaymentInfoError })}
                  onClick={this.state.tabValue === 1 ? this.buttonNextTabClick : this.onCreateNewAccount}
                  disabled={this.state.tabValue === 1 ? this.state.fieldsPersonalInfoError : this.state.fieldsPaymentInfoError}
                />
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }

  private initPaymentInfoForm = () => {
    let formValidator = new FormValidator<FormPaymentInfoType>([
      {
        name: FormPaymentInfoFields.CardNumber,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateCardNumber(value))) ?
            'cardNumber' :
            undefined
        },
        messages: {
          cardNumber: StringResources.getString(Strings.NewAccount.Errors.Messages.CardNumber)
        },
        masker: new Masker(Masker.cardNumber, Masker.placeSymbol),
        passMaskedToValidation: true
      },
      {
        name: FormPaymentInfoFields.CardExpirationDate,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateExpireDateStr(value))) ?
            'expire' :
            undefined
        },
        messages: {
          expire: StringResources.getString(Strings.NewAccount.Errors.Messages.ExpirationDate)
        },
        masker: new Masker(Masker.expireDateMask, Masker.placeSymbol),
        passMaskedToValidation: true
      },
      {
        name: FormPaymentInfoFields.CardCvv,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateCvc(value))) ?
            'cvv' :
            undefined
        },
        messages: {
          cvv: StringResources.getString(Strings.NewAccount.Errors.Messages.CVV)
        }
      }
    ])
    return formValidator
  }

  private initPersonalInfoForm = () => {

    const passwordConfirm: Validator = (value: any) => {
      return !value ? 'passConfirm' : (value === this.state.password ? undefined : 'passConfirm')
    }
    let formValidator = new FormValidator<FormPersonalInfoType>([
      /*{
        name: FormPersonalInfoFields.Avatar,
        value: '',
        validator: Validators.empty,
        messages: {
          empty: messages.PERSONAL_INFO.SET_PROFILE_PICTURE
        }
      },*/
      {
        name: FormPersonalInfoFields.FirstName,
        value: '',
        validator: Validators.name,
        messages: {
          name: StringResources.getString(Strings.NewAccount.Errors.Messages.FirstName)
        }
      },
      {
        name: FormPersonalInfoFields.LastName,
        value: '',
        validator: Validators.name,
        messages: {
          name: StringResources.getString(Strings.NewAccount.Errors.Messages.LastName)
        }
      },
      {
        name: FormPersonalInfoFields.Email,
        value: '',
        validator: Validators.email,
        messages: {
          email: StringResources.getString(Strings.NewAccount.Errors.Messages.Email)
        }
      },
      {
        name: FormPersonalInfoFields.Phone,
        value: '',
        validator: Validators.phone,
        messages: {
          phone: StringResources.getString(Strings.NewAccount.Errors.Messages.Phone)
        },
        masker: new Masker(Masker.numberMask, Masker.placeSymbol)
      },
      {
        name: FormPersonalInfoFields.ZipCode,
        value: '',
        validator: Validators.zipCode,
        messages: {
          phone: StringResources.getString(Strings.NewAccount.Errors.Messages.ZipCode)
        },
        masker: new Masker(Masker.zipCodeMask, Masker.placeSymbol)
      },
      {
        name: FormPersonalInfoFields.Password,
        value: '',
        validator: Validators.password,
        messages: {
          pass: StringResources.getString(Strings.NewAccount.Errors.Messages.Password)
        }
      },
      {
        name: FormPersonalInfoFields.PasswordConformation,
        value: '',
        validator: passwordConfirm,
        messages: {
          passConfirm: StringResources.getString(Strings.NewAccount.Errors.Messages.ConfirmPassword)
        }
      }
    ])
    return formValidator
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | SignInActionType | ErrorInfoActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    onUserSigned: (userData: ClientInfo) => dispatch(SignInActions.authorize(userData)),
    onSetTutorialLink: (link: Preference) => dispatch(SignInActions.setTutorialLink(link)),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo)),
    onLogOut: () => dispatch(SignInActions.logOut())
  }
}

export const NewAccountContainer = connect(
  undefined,
  mapDispatchToProps
)(NewAccount)



// WEBPACK FOOTER //
// ./src/containers/NewAccount.tsx